
import { Vue } from "vue-class-component";
export default class Test extends Vue {
  public graph: any = "";
  public mounted() {
    this.graph = "https://nzmperf.woa.com/";
  }
}
